class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");

    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code && event.code.toUpperCase() === "ESCAPE" && this.close()
    );
    this.summaryToggle.addEventListener("click", this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener("click", this.close.bind(this));

    this.summaryToggle.setAttribute("role", "button");
  }

  onSummaryClick(event) {
    console.log("onSummaryClick");
    event.preventDefault();
    event.target.closest("details").hasAttribute("open") ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains("modal-overlay"))
      this.close(false);
  }

  open(event) {
    setHeaderHeight();
    setScrollbarWidth();

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("search-modal--open");

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    console.log("close");
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("search-modal--open");
    this.querySelector(".predictive-search").classList.add("hide-predictive-search");
    if (this.querySelector(".search-modal.modal__content.searching")) {
      this.querySelector(".search-modal.modal__content.searching").classList.add(
        "hide-search-modal"
      );
    } else {
      // if (this.querySelector('.search-modal.modal__content.hide-search-modal-tablet')) {
      //   this.querySelector('.search-modal.modal__content.hide-search-modal-tablet').classList.remove('hide-search-modal-tablet');
      // } else {
      //   this.querySelector('.search-modal.modal__content').classList.add('hide-search-modal-tablet');
      // }
    }
  }
}

customElements.define("search-modal", SearchModal);
